export const environment = {
    production: true,
    socket: 'http://api.studytest.ru:5000',
    api: 'http://api.studytest.ru/'
};
